import axiosClient from "./axiosClient";

const roleApi = {
    getAllRole: () =>{
        const url = `api/role/getall`
        return axiosClient.get(url)
    },
}
export default roleApi;